import React from "react";
const IconAlert = (props) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M11.25 9.75C11.25 9.336 11.586 9 12 9C12.414 9 12.75 9.336 12.75 9.75V14.25C12.75 14.664 12.414 15 12 15C11.586 15 11.25 14.664 11.25 14.25V9.75Z",
  fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M12 17.9697C11.5343 17.9697 11.1562 17.5917 11.1562 17.126C11.1562 16.6595 11.5343 16.2822 12 16.2822C12.4657 16.2822 12.8438 16.6595 12.8438 17.126C12.8438 17.5917 12.4657 17.9697 12 17.9697Z",
  fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M12.6585 3.39094C12.3742 2.86969 11.6257 2.86969 11.3415 3.39094L2.3415 19.8909C2.06925 20.3904 2.43075 21.0002 3 21.0002H21C21.5692 21.0002 21.9307 20.3904 21.6585 19.8909L12.6585 3.39094V3.39094ZM4.26375 19.5002L12 5.31619L19.737 19.5002H4.26375V19.5002Z",
  fill: "currentColor"
}));
var IconAlert_default = IconAlert;
export {
  IconAlert_default as default
};
